import { useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import PageHeader from "../../../components/PageHeader";
import Button from "../../../components/Button";
import ProgrammeFormFields from "../../programmes/ProgrammeFormFields";
import { useCreateProgramme } from "../../../../hooks/useCreateProgramme";
import type { ProgrammeDto } from "../../../../api/programmesApi";

export default function ProgrammeCreateInParcours() {
  const { id = "" } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const initialDate = searchParams.get("date") ?? "";
  const [draft, setDraft] = useState<ProgrammeDto>({
    title: "",
    date: initialDate || undefined,
    parcoursId: id,
  });
  const create = useCreateProgramme();

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    create.mutate(
      { ...draft, parcoursId: id },
      { onSuccess: () => navigate(`/admin/parcours/${id}/programmes`) },
    );
  };

  return (
    <form onSubmit={onSubmit}>
      <PageHeader
        title="Nouveau programme"
        description={
          initialDate
            ? `Ce programme sera rattaché au jour du ${initialDate}.`
            : "Ce programme sera rattaché au parcours courant."
        }
        actions={
          <>
            <Button type="button" variant="ghost" onClick={() => navigate(`/admin/parcours/${id}/programmes`)}>
              Annuler
            </Button>
            <Button type="submit" variant="primary" loading={create.isPending}>
              Créer
            </Button>
          </>
        }
      />
      <div className="bo-card">
        <ProgrammeFormFields value={draft} onChange={setDraft} />
      </div>
    </form>
  );
}
